import Icon from '../components/Icon.vue'

Icon.register({
  route: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 320H320C302.4 320 288 305.6 288 288S302.4 256 320 256H416S512 149 512 96 469 0 416 0 320 43 320 96C320 121.5 342.2 159.4 365.3 192H320C267.1 192 224 235.1 224 288S267.1 384 320 384H416C433.6 384 448 398.4 448 416S433.6 448 416 448H185.5C169.5 472.8 151.7 495.7 138.2 512H416C468.9 512 512 468.9 512 416S468.9 320 416 320zM416 64C433.7 64 448 78.3 448 96S433.7 128 416 128 384 113.7 384 96 398.3 64 416 64zM96 256C43 256 0 299 0 352S96 512 96 512 192 405 192 352 149 256 96 256zM96 384C78.3 384 64 369.7 64 352S78.3 320 96 320 128 334.3 128 352 113.7 384 96 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/route.js
// module id = 9BUe
// module chunks = 144